import React from "react";

import { TagContainer, TagLabel } from "./styles";

interface CustomTagProps {
  autoGenerated?: boolean;
  backgroundColor: React.CSSProperties["backgroundColor"];
  color: React.CSSProperties["color"];
  children: React.ReactNode;
}

const CustomTag = React.forwardRef<HTMLDivElement, CustomTagProps>(
  ({ autoGenerated = false, backgroundColor, color, children }, ref) => (
    <TagContainer variant="left" ref={ref} sx={{ backgroundColor, color }}>
      <TagLabel>
        {autoGenerated && "✨ "}
        {children}
      </TagLabel>
    </TagContainer>
  )
);

CustomTag.displayName = "CustomTag";

export default CustomTag;
